import React from "react"

const ChatNotificationPopup = ({ message, senderName, onClick, onDismiss }) => {
  if (!message) return null

  // Get initials from sender name
  const getInitials = (name) => {
    return name
      .split(" ")
      .map((part) => part.charAt(0))
      .join("")
      .toUpperCase()
      .slice(0, 2)
  }

  const initials = getInitials(senderName || "C")

  return (
    <div className="fixed bottom-32 right-6 z-50 animate-slide-in-right">
      <div
        onClick={onClick}
        className="bg-[#3c4043] hover:bg-[#494d51] rounded-lg shadow-2xl cursor-pointer transition-all duration-200 w-80"
      >
        <div className="flex items-center gap-3 px-4 py-3">
          {/* Avatar */}
          <div className="flex-shrink-0">
            <div className="w-10 h-10 rounded-full bg-[#8b6f5e] flex items-center justify-center text-white text-sm font-semibold">
              {initials}
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0">
            <div className="text-white text-sm font-medium mb-0.5">
              {senderName}
            </div>
            <p className="text-gray-300 text-xs truncate">{message}</p>
          </div>

          {/* Reply/Back Arrow icon */}
          <div className="flex-shrink-0">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="text-gray-400"
            >
              <path d="M9 14l-5-5 5-5" />
              <path d="M20 20v-7a4 4 0 0 0-4-4H4" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChatNotificationPopup
